module.exports = __webpack_public_path__ + "0cca9a700e2180795d8f78b181d337f8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/side-table.png
// module id = 3218
// module chunks = 0